import axios from 'axios';

export default function getWireStatistics(wireId) {
  return axios.get(`/api/v1/wire/${wireId}/statistics`);
}
